import { createContext } from 'react';
import { FacilityStatusEnum } from '../../api';

export interface PresentationStatusContextType {
  onchange: ({ status, id }: { status: FacilityStatusEnum; id: string }) => void;
  isDisabled: boolean;
}

export const PresentationStatusContext = createContext<PresentationStatusContextType>({
  onchange: () => {},
  isDisabled: false,
});
